var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.113 0C4.088 0 0 3.925 0 8.75s4.088 8.75 9.113 8.75c5.025 0 9.113-3.925 9.113-8.75S14.138 0 9.113 0zm0 1.75c4.02 0 7.29 3.14 7.29 7s-3.27 7-7.29 7-7.29-3.14-7.29-7 3.27-7 7.29-7zM5.468 7.875v1.75h7.29v-1.75h-7.29z"
  })));
}
export default SvgMinus;